<template>
    <!--   场地管理－优惠券管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this, 'coupon')">
        <div slot="header">

            <a-form :form="form" layout="inline" class="store-one-form">
                <a-form-item label="优惠券名称">
                    <a-input placeholder="请输入" v-decorator="['name']"></a-input>
                </a-form-item>
                <a-form-item label="优惠券状态">
                    <a-select allowClear placeholder="请选择" v-decorator="['state']">
                        <a-select-option value="1">已生效</a-select-option>
                        <a-select-option value="0">未生效</a-select-option>
                        <a-select-option value="2">已失效</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="优惠券类型">
                    <a-select allowClear placeholder="请选择" v-decorator="['type']">
                        <a-select-option value="1">优惠券</a-select-option>
                        <a-select-option value="2">折扣券</a-select-option>
                        <a-select-option value="3">分享券</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="生效时间">
                    <a-range-picker
                        style="width:282px"
                        showTime
                        format="YYYY/MM/DD HH:mm"
                        v-decorator="['selectDate']"
                    />
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
            </a-form>
        </div>

        <div class="container">
                <router-link v-if="getBtnByAuth('newAddCoupon')" to="/coupon/newAddCoupon">
                    <a-button type="primary" style="margin-bottom:10px">新增优惠券</a-button>
                </router-link>

            <a-table
            bordered
            :dataSource="dataSource"
            :columns="columns"
            :pagination="pagination"
            @change="changePage"
            :rowKey="(record,index) => index"
            >
            <span slot="index" slot-scope="a,item,i">{{i+1}}</span>
            <span slot="type" slot-scope="type">{{['','优惠劵','折扣劵','分享券'][type]}}</span>
            <span slot="rule" slot-scope="rule">{{rule ? rule : "-"}}</span>
            <span slot="state" slot-scope="state">{{['未生效','已生效','已失效'][state]}}</span>
            <span slot="limitNum" slot-scope="limitNum">{{!limitNum ? "-" : limitNum === -1 ? '不限量' : limitNum}}</span>
            <span slot="remindNum" slot-scope="remindNum">{{!remindNum ? "-" : remindNum === -1 ? '不限量' : remindNum}}</span>
            <span slot="action" slot-scope="a,item">
                <a v-if="getBtnByAuth('couponDetail')" @click="couponDetail(item.id)" class="text-primary">详情<a-divider type="vertical" /></a>
                <a v-if="getBtnByAuth('couponDetail')" @click="couponUser(item)" class="text-primary">分发用户查看<a-divider type="vertical" /></a>
                <a-popconfirm
                    title="确认删除吗？"
                    @confirm="couponDelete(item.id)"
                    >
                    <a class="text-primary">删除</a>
                </a-popconfirm>
            </span>
            </a-table>
        </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import moment from "moment";
    import { constants } from "fs";
    export default {
        name: "coupon",
        components: {},
        props: {},
        data() {
            return {
            dataSource: [],
            columns,
            // 分页
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                current: 1,
                pageSize: 20
            }
            };
        },
        computed: {},
        watch: {
            $route: function(newVal, oldVal) {
                if (newVal.name === "coupon") {
                    this.getList();
                }
            }
        },
        methods: {
            handleReset() {
                this.form.resetFields();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            //获取列表
            getList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const rangeValue = values['selectDate'] ? values['selectDate'] : []
                    values.validStartTime = rangeValue.length > 0 ? rangeValue[0].format('YYYY-MM-DD HH:mm:ss') : undefined
                    values.validEndTime = rangeValue.length > 0 ? rangeValue[1].format('YYYY-MM-DD HH:mm:ss') : undefined
                    this.$api.totalPlatform
                        .couponList({
                            body: Object.assign(values, {
                                pageNum: this.pagination.current,
                                pageSize: this.pagination.pageSize
                            })
                        })
                        .then(res => {
                            this.dataSource = res.list;
                            this.$set(this.pagination, "total", Number(res.total));
                        });
                });
            },
            // 时间选择
            moment,
            onChangePicker(value, data) {
                this.validEndTime = data[0];
                this.validStartTime = data[1];
            },

            couponDetail(item) {
                this.$router.push({
                    path: "/coupon/couponDetail",
                    query: { id: item }
                });
            },
            couponUser(item) {
                if(item.type === 3) {
                    this.$router.push({
                    path: "/coupon/couponUserShare",
                    query: { id: item.id, name: item.name }
                    });
                }else {
                    this.$router.push({
                    path: "/coupon/couponUserDiscount",
                    query: { id: item.id, name: item.name }
                    });
                }
            },
            couponDelete(id) {
                this.$api.totalPlatform.couponDelete({
                    params: {id: id}
                })
                .then(res => {
                    this.$message.success('操作成功')
                    this.getList()
                })
            }
        },
            beforeCreate() {
                this.form = this.$form.createForm(this);
            },
        created() {},
        mounted() {
            this.getList();
        }
    };
    const columns = [
        {
            title: "序号",
            dataIndex: "index",
            scopedSlots: { customRender: "index" }
        },
        {
            title: "优惠券名称",
            dataIndex: "name"
        },
        {
            title: "优惠券类型",
            dataIndex: "type",
            scopedSlots: { customRender: "type" }
        },
        {
            title: "优惠规则",
            dataIndex: "rule",
            scopedSlots: { customRender: "rule" }
        },
        {
            title: "生效时间",
            dataIndex: "validTime"
        },
        {
            title: "状态",
            dataIndex: "state",
            scopedSlots: { customRender: "state" }
        },
        {
            title: "下发总数量",
            dataIndex: "limitNum",
            scopedSlots: { customRender: "limitNum" }
        },
        {
            title: "剩余数量",
            dataIndex: "remindNum",
            scopedSlots: { customRender: "remindNum" }
        },
        {
            title: "操作",
            dataIndex: "action",
            scopedSlots: { customRender: "action" }
        }
    ];
</script>
<style lang="scss">
    .container {
        background: #fff;
    }
</style>